import axios from 'axios';
import fileDownload from 'js-file-download';
import * as endpoint from '../../../endpoint';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForBlob } from '../../axiosConfig';

/**
 * タグ情報マスタ設定用のCSVファイル(一階層)のダンロードを行う。
 *
 * @param {string} apiToken - APIトークン
 * @returns {Function}
 */
const downloadTagsCsv = apiToken => dispatch => {
  consolelog('[API CALL] downloadTagsCsv()');
  configureAxiosForBlob(apiToken);
  const url = endpoint.API_DOWNLOAD_TAGS_CSV;
  const { cancelToken, cancelTokenKey } = createCancelToken('downloadTagsCsv');
  const params = {
    cancelToken,
  };

  return axios
    .get(url, params)
    .then(res => {
      delCancelToken(cancelTokenKey);
      const filename = res.headers['content-disposition'].split('=')[1];
      fileDownload(res.data, filename);
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default downloadTagsCsv;
